<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '信息发布')[0].value">
    <div style="margin-top: 3%;width: 80%;">
      <div style="text-align: center">
        <h3>{{ platformitme.name }}</h3>
      </div>
      <div>
        <el-form :model="informationForm"
                ref="informationForm"
                label-width="120px"
                title="信息发布">
          <el-form-item label="介绍：">
            {{ platformitme.describe }}
          </el-form-item>
          <el-form-item label="成本：">
            <span>{{String(platformitme.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}&nbsp;元</span>
          </el-form-item>
          <el-form-item label="流量：">
            <el-statistic :value="platformitme.flow" />
          </el-form-item>
          <el-form-item label="发布数量："
                        prop="number">
            <el-input v-model="informationForm.number"
                      class="inputs"
                      :disabled="idisabled"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                  :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                                  @input="inputChange"
                      maxlength="9">
                      <template #append>条</template>
                    </el-input>
          </el-form-item>
          <el-form-item label="发布目标："
                        prop="targetID">
            <el-select v-model="informationForm.targetID"
                      :disabled="idisabled"
                      class="m-2"
                      placeholder="Select">
              <el-option v-for="item in tagers"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="InformationClick" v-if="SModelInformationList.filter((t) =>t.state != Global.SModel.Delete&&t.platformID==this.platformitme.id).length == 0">
              {{SModelInformationList.filter((t) =>t.state != Global.SModel.Delete&&t.platformID==this.platformitme.id).length > 0? "取消": "发布"}}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["Platform"],
  components: {
    ShowControl,
  },
  data () {
    return {
      idisabled: false,
      flowID: localStorage.getItem("flowID"),
      platformitme: {},
      marketingMoney: 0,
      SModelInformationList: [],
      informationForm: {
        number: 1,
        targetID: 2,
      },
      tagers: this.Global.TargetType,
      title: '信息发布',
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      MarketCost: (state) => state.user.marketCostStatistics,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetInformations()
  },
  mounted () {
    this.GetSModelInformation();
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/MiceMarketing")
    },
    inputChange(val) {
      console.log(val);
      this.informationForm.number = this.informationForm.number.toString().replace(/[^0-9]/g, '')
    },
    GetInformations(){
      this.$http.get('Platform/GetModels?id='+this.$route.query.id).then((res) => {
          if (res.success) {
            this.platformitme = res.dynamicObj[0]
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    GetSModelInformation () {
      this.$http
        .get(
          "SModel/GetTypeSModel?round=" +
          this.Round +
          "&typename=S_Platform"
        )
        .then((res) => {
          if (res.success) {
            this.SModelInformationList = res.dynamicObj;
            if (this.SModelInformationList.filter(c => c.state != this.Global.SModel.Delete && c.platformID == parseInt(this.platformitme.id)).length > 0) {
              this.informationForm = this.SModelInformationList.filter(c => c.state != this.Global.SModel.Delete && c.platformID == this.platformitme.id)[0];
              this.idisabled = true;
            } else {
              this.idisabled = false;
            }
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    InformationClick () {
      if (this.flowID != this.Global.FlowList.招商) {
        this.$message.error("当前流程阶段不是招商，无法进行操作！");
        return;
      }
      let that = this;
      that.$refs.informationForm.validate((valid) => {
        if (valid) {
          //var sList=this.SModelInformationList.filter(c=>c.platformID!=this.platformitme.id&&c.state!=that.Global.SModel.Delete);
          // if(sList.length>0)
          // {
          //   this.$message.error("当前回合中只能选择一种信息营销方式！！");
          //     return;
          // }
          this.marketingMoney = this.informationForm.number * this.platformitme.cost;
          let list = that.SModelInformationList.filter(c => c.platformID == this.platformitme.id);
          if (list.filter(c => c.state != that.Global.SModel.Delete).length > 0) {
            list[0].state = that.Global.SModel.Delete;
            that.$http
              .post("SModel/PushStrategy", that.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  this.Global.GetBudget(-this.marketingMoney);
                  that.Global.sendmsgmd(
                    "会展营销",
                    `取消了${this.platformitme.name}信息发布，增加了${this.marketingMoney}元`,
                    1
                  );
                  var incomet = [{
                    buissType: that.Global.PayType.信息发布成本,
                    round: this.Round,
                    buissId: this.platformitme.id
                  }];
                  that.API.pushIncomet(incomet,1);
                  that.GetSModelInformation();
                  that.$store.commit("marketStatistics", !this.MarketCost);  
                  that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.delete,'信息发布');
                } else {
                  that.$message.error(res.message);
                  return false;
                }
              });
          } else {
            if (this.marketingMoney == 0) {
              this.$message.error("营销投入为0");
              return;
            } else if (!this.Global.GetBudget(this.marketingMoney)) {
              this.$message.error("资金不足");
              return;
            }
            if (list.length == 0) {
              list = [];
              list.push(that.informationForm)
              list[0].uuid = that.uuid.guid();
              //list[0].number=list[0].number.replace(/,/g, "")
              list[0].state = that.Global.SModel.Create;
            } else {
              let uuid = list[0].uuid;
              list = [];
              list.push(that.informationForm)
              //list[0].number=list[0].number.replace(/,/g, "")
              list[0].state = that.Global.SModel.Update;
              list[0].uuid = uuid;
            }
            list[0].round = that.Round;
            list[0].type = "S_Platform";
            list[0].sTTime = that.filter.formatDate(new Date());
            list[0].cost = this.marketingMoney;
            list[0].platformID = this.platformitme.id;
            that.$http
              .post("SModel/PushStrategy", that.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  that.Global.sendmsgmd(
                    "会展营销",
                    `操作了${this.platformitme.name}信息发布，扣减了${this.marketingMoney}元`,
                    1
                  );
                  var incomet = [{
                    buissType: that.Global.PayType.信息发布成本,
                    buissValue: this.marketingMoney,
                    name: '信息发布成本',
                    describe: '',
                    round: this.Round,
                    buissId: this.platformitme.id
                  }];
                  that.API.pushIncomet(incomet,0);
                  that.GetSModelInformation();
                   that.$store.commit("marketStatistics", !this.MarketCost);   
                   that.$store.commit("chatShow",{ isOperate : !that.ChatShow, chatValue: that.Global.OperateType.信息发布, buissId : this.platformitme.id });  
                   that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.normal,'信息发布');
                } else {
                  that.$message.error(res.message);
                  return false;
                }
              });

          }

        }
      });

    },
    // GetTargerMD() {
    //   this.$http.get("ExhibitionIndustry/GetModel").then((res) => {
    //     if (res.success) {
    //       this.tagers = res.dynamicObj;
    //     } else {
    //       this.$message.warning(res.message);
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.inputs {
  width: 90%;
}
</style>